import { Box } from "@material-ui/core"
import { Reply } from "@material-ui/icons"

export const ReplyInTaskButton = ({
  onClick
}: {
  onClick: () => void
}) => {
  return (
    <Box onClick={onClick}>
      <Box
        fontWeight={'bold'}>
        <span>
          <Reply style={{
            fontSize: 10
          }} />
        </span>
        <span style={{
          cursor: 'pointer',
          textDecoration: 'underline'
        }}>
          REPLY IN TASK
        </span>
      </Box>
    </Box>
  )
}